import { screenSizes } from '@shipt/design-system-themes'
import { useHydrated } from '@/features/shared/components/ClientOnly'
import { useMedia } from '@/features/shared/hooks/useMedia'

const { max_mobile, tablet, smDesktop } = screenSizes

export const useMediaQuery = () => {
  const isHydrated = useHydrated()
  const screenSm = useMedia(max_mobile, isHydrated ? undefined : true)
  const screenMd = useMedia(tablet, isHydrated ? undefined : false)
  const screenLg = useMedia(smDesktop, isHydrated ? undefined : false)
  return { screenSm, screenMd, screenLg }
}
